import { useTranslation } from 'react-i18next';
import type { ExploitRuleHostConfig } from '../../types/exploit-rules';

interface ExploitHostCardProps {
  host: ExploitRuleHostConfig;
  onManage: () => void;
}

export function ExploitHostCard({ host, onManage }: ExploitHostCardProps) {
  const { t } = useTranslation('exploitRules');

  return (
    <div className="rounded-lg border p-4 bg-amber-50 dark:bg-amber-900/10 border-amber-200 dark:border-amber-900/30">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white">
              {host.proxy_host_name || 'Unnamed Host'}
            </h3>
            <span className="px-2 py-0.5 text-xs rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400">
              {t('hostList.status.exploitBlockEnabled')}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-amber-200 dark:border-amber-900/30 flex items-center justify-between">
        <div className="text-sm">
          {host.exclusion_count > 0 ? (
            <span className="text-amber-600 dark:text-amber-400 font-medium">
              {t('hostList.rulesDisabled', { count: host.exclusion_count })}
            </span>
          ) : (
            <span className="text-gray-500 dark:text-slate-500">{t('hostList.allRulesEnabled')}</span>
          )}
        </div>
        <button
          onClick={onManage}
          className="px-3 py-1.5 text-sm rounded-lg transition-colors bg-amber-600 text-white hover:bg-amber-700 dark:hover:bg-amber-500"
        >
          {t('hostList.managePolicy')}
        </button>
      </div>
    </div>
  );
}
